import { Box } from "@mui/system";
import { PolygonLayer, LayerEvent, MapScene, Control, Popup, ColorComponent } from '@antv/l7-react';
import React, { useEffect, useState } from 'react';
import { usePapaParse } from 'react-papaparse';
import DownloadButton from "../Common/DownloadButton";


const CommodityMap = (props) => {

    const filter = props.filter;
    const buttonsFilter = props.buttonsFilter;
    const json = props.json;
    const csv = props.csv;
    const { readString } = usePapaParse();
    const [hovered, setHovered] = useState(undefined);
    const [chart, setChart] = useState(undefined);
    const [unknown, setUnknown] = useState(undefined);

    const initialState = {
        json: null, conv: null
    }
    const [data, setData] = useState(initialState);

    const [mapEmptyState, setMapEmptyState] = useState(3);

    const handleReadString = () => {

        readString(csv, {
            complete: (results, file) => {
                json.features.map(j => {
                    let sum = 0;
                    results.data.filter(d => {
                        return d['Country of origin of the sample taken'] === j.properties['NAME_ENGL'] && d['Food commodity'] === filter
                    }).forEach(f => {
                        sum += f[buttonsFilter];
                    })
                    j.properties = { ...j.properties, sum };
                    return j;
                });

                if (chart) {
                    chart.layer.setData(json);
                }

                setData({ json: json, conv: results.data });
                const len = results.data.filter(d => d['Food commodity'] === filter).length;
                setMapEmptyState(len);
                let sumUnkown = 0;
                setUnknown(results.data.filter(d => d['Food commodity'] === filter).forEach(f => {
                    if (f['Region'] === 'Unknown') {
                        sumUnkown += f[buttonsFilter] ? f[buttonsFilter] : 0;
                    }
                }));
                setUnknown(sumUnkown);
            },
            download: true,
            header: true,
            dynamicTyping: true,
            error: (error, file) => {
                console.log('Error while parsing:', error, file);
            },
        });

    };

    const handleLoaded = (scene, layer) => {
        setChart({ scene, layer });
    }

    useEffect(() => {
        handleReadString();
    }, [filter, buttonsFilter]);

    const [canvas, setCanvas] = useState(undefined);

    const getTooltipContent = (country) => {
        const found = data.conv.find(d => d['Country of origin of the sample taken'] === country && d['Food commodity'] === filter);
        if (found) {
            return <p>
                {Object.keys(found).map(f => {
                    if (f === 'Food commodity' || f === 'Country of origin of the sample taken') {
                        return ''
                    }
                    return <span style={{ display: 'block', fontSize: '14px' }}> {f + ':' + found[f]}</span>
                })}
            </p>;
        }
    }

    const getSemiEmptyState = () => {
        const metric = buttonsFilter === 'Above legal limit result' ? 'MRL Exceedances' : 'Non-compliant samples';

        let originAndCountry = '';
        data.conv.filter(d => d['Food commodity'] === filter).forEach((f, idx) => {
            if (idx === 0) {
                originAndCountry += (f['Region'] === "EU" ? f['Region'] + ' country' : f['Region']) + ' (' + f['Country of origin of the sample taken'] + ')';
            } else {
                originAndCountry += " and one ";
                originAndCountry += (f['Region'] === "EU") ? f['Region'] + ' country' : f['Region'] + ' (' + f['Country of origin of the sample taken'] + ')';
            }
        });
        return metric + ' were related to products grown and/or potentially treated post harvest in one ' + originAndCountry;
    }
    const colors = ['#fff', '#CBDDEE', '#98BDDF', '#72A5D3', '#5894CB', '#2574BB', '#246898'];

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
    useEffect(() => {
        function handleResize() {
            setIsMobile(window.innerWidth <= 900)
        }
        window.addEventListener('resize', handleResize)
        return _ => {
            window.removeEventListener('resize', handleResize)
        }
    })
    useEffect(() => {
        const canvases = document.getElementsByClassName('l7-marker-container');
        for (let i = 0; i < canvases.length; i++) {
            canvases[i].onwheel = function (event) {
                event.stopPropagation();
            };
        }
    });

    return (
        <Box>
            {mapEmptyState > 2 && data.json &&
                <Box display='flex' justifyContent='flex-end'>
                    <div style={{ fontFamily: 'Roboto Condensed, sans-serif', minWidth: isMobile ? '250px' : '300px' }}>
                        <ColorComponent items={[
                            { title: '1', color: '#CBDDEE' },
                            { title: '2', color: '#98BDDF' },
                            { title: '3', color: '#72A5D3' },
                            { title: '4', color: '#5894CB' },
                            { title: '5', color: '#2574BB' },
                            { title: '6+', color: '#246898' },
                        ]} />
                    </div>
                    <DownloadButton isMap canvas={canvas} fileName='Map' csv={data.conv} />
                </Box>
            }
            {mapEmptyState > 2 && data.json && <MapScene
                onSceneLoaded={(scene) => {
                    setCanvas(scene);
                }}
                autoFit
                map={{
                    pitch: 0,
                    style: 'blank',
                    zoom: 0,
                    minZoom: 0,
                    maxZoom: 4,
                    center: [112, 30],
                }}
                style={{
                    height: '500px',
                    position: 'relative',
                }}
            >
                <PolygonLayer
                    onLayerLoaded={(layer, scene) => {
                        handleLoaded(scene, layer);
                    }}
                    key={2}
                    zIndex={1}
                    source={{
                        data: data.json
                    }}
                    color={{
                        field: 'sum',
                        values: (d) => {
                            return d >= (colors.length - 1) ? colors[colors.length - 1] : colors[d];
                        }
                    }}
                    options={{
                        autoFit: true,
                    }}
                    size={{
                        values: 1,
                    }}
                    shape={{
                        values: 'fill',
                    }}
                    active={{
                        option: {
                            color: '#C6C2C2',
                        },
                    }}
                >
                    <LayerEvent
                        type="mouseenter"
                        handler={e => {
                            setHovered(e);
                        }}
                    ></LayerEvent>
                    <LayerEvent
                        type="mouseout"
                        handler={e => {
                            setHovered(undefined);
                        }}
                    ></LayerEvent>
                </PolygonLayer>
                <PolygonLayer source={data.json}
                    key={1}
                    source={{
                        data: data.json,
                    }}
                    size={{
                        values: .5,
                    }}
                    color={{
                        values: '#C6C2C2',
                    }}
                    shape={{
                        values: 'line',
                    }}
                    style={{
                        opacity: 0.5,
                    }}
                    zIndex={10}
                />
                {hovered && data.conv.find(d => d['Country of origin of the sample taken'] === hovered.feature.properties.NAME_ENGL && d['Food commodity'] === filter) &&
                    <Popup option={{ stopPropagation: false, maxWidth: '300px' }} lnglat={hovered?.lngLat}>
                        <div className="tooltipWrapper" style={{ padding: '.5rem' }}>
                            {<b>{hovered.feature.properties.NAME_ENGL}</b>}
                            <br />
                            {getTooltipContent(hovered.feature.properties.NAME_ENGL)}
                        </div>
                    </Popup>
                }
                <Control type="scale" position="bottomright" />
                <Control type="zoom" position="bottomright" />
            </MapScene>
            }
            {unknown > 0 &&
                < div className="unknown-legend-wrapper" style={{ fontFamily: 'Roboto Condensed, sans-serif', width: '100px' }}>
                    <ColorComponent items={[
                        { title: 'Unknown: ' + unknown, color: '#808080' },
                    ]} />

                </div>
            }
            {
                mapEmptyState === 0 &&
                <Box display='flex' justifyContent='center'>
                    <p style={{
                        color: 'white',
                        fontWeight: '700',
                        maxWidth: '280px',
                        textAlign: 'center',
                        fontSize: '14px',
                        backgroundColor: '#00B289',
                        padding: '0 10px 0 10px'
                    }}>No {buttonsFilter === 'Above legal limit result' ? 'MRL exceedances' : 'non-compliant samples'} were reported to this food product.</p>
                </Box>
            }

            {
                mapEmptyState > 0 && mapEmptyState < 3 &&
                <Box display='flex' justifyContent='center'>
                    <p style={{
                        color: 'white',
                        fontWeight: '700',
                        maxWidth: '350px',
                        textAlign: 'center',
                        fontSize: '14px',
                        backgroundColor: '#00B289',
                        padding: '0 10px 0 10px'
                    }}>{getSemiEmptyState()}
                    </p>
                </Box>
            }

        </Box >
    );

}

export default CommodityMap;